// extracted by mini-css-extract-plugin
export var paginationContainer = "_7i-0";